import { useMemo } from 'react'

import { useUserOrganization, useUserOrganizationSettings } from '@modules-deprecated/app/organization'
import { useUserOrganizationMembership } from '@modules-deprecated/app/organization/hooks/useUserOrganizationMembership'

import { LabsFlag } from '../../../enums/labsFlag'
import { useFetchUserUmbrellas } from '../../../hooks/useFetchUserUmbrellas'
import { useLabsMenuFlags } from '../../../hooks/useLabsMenuFlags'
import { LEGACY_RECONCILIATION_VIEW_COUNTRY_ID } from '../constants/legacyReconciliationViewCountryId'
import { BankTransactionsAccess, getBankTransactionsAccess } from '../utils/getBankTransactionsAccess'

export const useBankTransactionsAccess = (): BankTransactionsAccess => {
  const { organization } = useUserOrganization()
  const { userUmbrellas } = useFetchUserUmbrellas()
  const { organizationSettings } = useUserOrganizationSettings()
  const { isViaUmbrella } = useUserOrganizationMembership()
  const labsFlags = useLabsMenuFlags()

  const isLegacyReconciliationViewEnabled =
    organization?.countryId === LEGACY_RECONCILIATION_VIEW_COUNTRY_ID &&
    organizationSettings?.isLegacyReconciliationViewEnabled === '1'
  const isReconciliationViewAsDefaultFlagEnabled = labsFlags[LabsFlag.ReconciliationViewAsDefault]

  const ownerUmbrellaId = organization?.ownerUmbrellaId
  const isOwnerUmbrellaMember =
    !!ownerUmbrellaId && userUmbrellas.some((userUmbrella) => userUmbrella.umbrellaId === ownerUmbrellaId)
  const isUmbrellaUser = isViaUmbrella || isOwnerUmbrellaMember

  return useMemo(
    () =>
      getBankTransactionsAccess({
        isLegacyReconciliationViewEnabled,
        isReconciliationViewAsDefaultFlagEnabled,
        isUmbrellaUser,
      }),
    [isLegacyReconciliationViewEnabled, isReconciliationViewAsDefaultFlagEnabled, isUmbrellaUser],
  )
}
